<template>
    <v-select v-model="object" :options="items" @search="search">
        <template slot="option" slot-scope="option">
            <div class="media">
                <img
                    class="mr-3 rounded"
                    :src="option.photo"
                    height="45"
                    alt="Foto"
                />
                <div class="media-body">
                    <h5 class="mt-0">{{ option.label }}</h5>
                </div>
            </div>
            <!-- <div class="d-flex">
                <img :src="option.photo" height="25" class="" alt="">
                <div>{{ option.label }} ({{ option.document }}) - {{ option.type }}</div>
            </div> -->
        </template>
        <span slot="no-options">Escriba para iniciar la búsqueda.</span>
        <i
            v-if="loading"
            slot="spinner"
            class="fa fa-spinner"
            aria-hidden="true"
        ></i>
    </v-select>
</template>
<script>
import vigilanceRepository from '../../../../repositories/vigilance.repository'
export default {
    inheritAttrs: false,
    props: {
        minSize: {
            type: Number,
            default: 3,
        },
    },
    data() {
        return {
            object: null,
            results: [],
            loading: false,
        }
    },
    watch: {
        object(val) {
            this.$emit('input', val.document)
        },
    },
    computed: {
        items() {
            if (!this.results.length) return []

            const items = this.results.map((item) => {
                let type = !!item.internal ? 'Interno' : 'Visitante'
                if (item.hasOwnProperty('plate')) {
                    // Vehiculo
                    return {
                        label: `${item.brand} (${item.plate}) - ${type}`,
                        document: item.plate,
                        type,
                        photo: !!item.vehicle_photos.length
                            ? item.vehicle_photos[0].photo_url
                            : 'images/genericcar.png',
                    }
                } else {
                    // Persona
                    return {
                        label: `${item.name} (${item.document}) - ${type}`,
                        document: item.document,
                        type,
                        photo: !!item.photo
                            ? item.photo
                            : 'images/avatar_empty.png',
                    }
                }
            })

            return items
        },
    },
    methods: {
        search(search, loading) {
            if (search.trim().length < this.minSize) return

            this.loading = loading

            const vr = { ...vigilanceRepository }
            vr.searchPersonOrVehicle(this.client.id, search)
                .then((data) => {
                    this.loading = false
                    this.results = data
                })
                .catch((error) =>
                    toastr.error(
                        'Ocurrió un error al consultar las personas o vehículos'
                    )
                )
        },
    },
}
</script>
